// ArlistsVirtualList.jsx
// This component renders a virtualized list of artwork images for selecting an artlist cover.
// It uses react-virtualized to efficiently render a large list and highlights the currently
// selected cover image. It also provides a fallback for the aspect ratio in case the data is missing.

import { memo, useRef } from 'react';
import { AutoSizer, List } from 'react-virtualized';

import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';

import './styles/VirtualList.css';

const ArlistsVirtualList = memo(({ formState, onSelectImage }) => {
  const listRef = useRef();

  return (
    <AutoSizer onResize={() => listRef.current.recomputeRowHeights()}>
      {({ width, height }) => (
        <List
          width={width}
          height={height}
          rowCount={formState.artlist_artworks.length}
          overscanRowCount={5}
          ref={listRef}
          className="remove-scrollbar"
          rowHeight={({ index }) => {
            // Use optional chaining and a fallback aspect ratio of 1 if not defined.
            const aspectRatio = formState.artlist_artworks[index]?.artwork_media?.artwork_main_picture?.image_original_data?.aspect_ratio || 1;
            return width <= 528 ? (150 / aspectRatio) + 15 : (180 / aspectRatio) + 15;
          }}
          rowRenderer={({ index, key, style }) => {
            // Get the artwork's main picture safely.
            const artwork = formState.artlist_artworks[index]?.artwork_media?.artwork_main_picture;
            // Determine if this artwork is currently the cover.
            const isActive = formState.artlist_image?.image_id === artwork?.image_id;
          
            return (
              <div key={key} style={style}>
                <ArtworkImage
                  image={artwork?.image_id}
                  onClick={() => {
                    console.log('ArlistsVirtualList: Artwork clicked:', artwork);
                    onSelectImage(artwork);
                  }}
                  imageClassName={`edit-artlist__change-image-item ${isActive ? "active" : ""}`}
                  imageTemplateClassName="edit-artlist__change-image-item"
                  // Use fallback aspect ratio if missing.
                  style={{ aspectRatio: artwork?.image_original_data?.aspect_ratio || 1 }}
                  enabledDoubleClick={false}
                />
              </div>
            );
          }}          
        />
      )}
    </AutoSizer>
  );
});

ArlistsVirtualList.displayName = 'ArlistsVirtualList';
export default ArlistsVirtualList;
